var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallRightArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 19,
    viewBox: "0 0 11 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1018 9.31325C10.1018 9.57148 10.0088 9.79872 9.81257 9.99497L1.62166 18C1.44606 18.1859 1.21883 18.2788 0.95027 18.2788C0.413161 18.2788 0 17.876 0 17.3389C0 17.0703 0.113619 16.8431 0.278884 16.6675L7.79841 9.31325L0.278884 1.95898C0.113619 1.78339 0 1.54582 0 1.2876C0 0.750488 0.413161 0.347656 0.95027 0.347656C1.21883 0.347656 1.44606 0.440617 1.62166 0.616211L9.81257 8.63153C10.0088 8.81746 10.1018 9.05502 10.1018 9.31325Z",
    fill: "#C93030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallRightArrowIcon);
export default __webpack_public_path__ + "static/media/small-right-arrow-icon.43eb46cb0977b4094d1841b77d14bb14.svg";
export { ForwardRef as ReactComponent };